// Câmbio implícito de uma linha do ponto de partida: custo médio em reais ÷
// custo médio na moeda. Os dois custos são digitados à parte; quando um deles
// muda de escala sem o outro (ex.: ajustar quantidade e custo em dólar por
// um desdobramento e esquecer o custo em reais), a razão sai muito longe do
// PTAX da data e o total em reais da custódia fica errado.
//
// Faixa aceita em relação ao PTAX da data do ponto de partida: o custo vem de
// compras ao longo dos anos, então o câmbio implícito pode ser bem menor que
// o da data (real mais forte no passado) — até 1/4 dele —, mas não deveria
// passar de 1,5× (o real nunca se valorizou tanto de lá para cá). Um erro de
// digitação de 10× cai fora dos dois lados.
export const LIMITE_INFERIOR = 0.25;
export const LIMITE_SUPERIOR = 1.5;

export type SituacaoCambio =
  | { tipo: "sem-custos" }
  | { tipo: "sem-moeda" }
  | { tipo: "sem-brl" }
  | { tipo: "ok"; implicito: number }
  | { tipo: "fora"; implicito: number; ptax: number };

// Checagem de plausibilidade, não de exatidão: o PTAX da data não é o câmbio
// de cada compra, então um custo antigo legítimo pode cair fora da faixa e
// um erro pequeno (ex.: 2×) pode cair dentro. O alvo são erros de escala.
export function avaliarCambioImplicito(
  custoMedioOriginal: number,
  custoMedioBRL: number,
  ptax?: number
): SituacaoCambio {
  const temMoeda = custoMedioOriginal > 0;
  const temBRL = custoMedioBRL > 0;
  if (!temMoeda && !temBRL) return { tipo: "sem-custos" };
  if (!temMoeda) return { tipo: "sem-moeda" };
  if (!temBRL) return { tipo: "sem-brl" };
  const implicito = custoMedioBRL / custoMedioOriginal;
  if (!ptax || !(ptax > 0)) return { tipo: "ok", implicito };
  const razao = implicito / ptax;
  if (razao < LIMITE_INFERIOR || razao > LIMITE_SUPERIOR) {
    return { tipo: "fora", implicito, ptax };
  }
  return { tipo: "ok", implicito };
}
